import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions'
import { createFolder, editFolder } from '../../actions/userActions'
import CloseIcon from '@mui/icons-material/Close';

class AddEditFolder extends React.Component {

    state = {
        folderName: "",
        customerID: "",
    }

    componentDidMount() {
      
        // set default customerID
        this.setState({ customerID: this.props.user.customerID });

        // get folder name
        // folder ID only exists in popupInfo when editing
        if (this.props.popupInfo != null) {
            let folder = this.props.folderList.find(x => x.id === this.props.popupInfo);
            this.setState({ folderName: folder.folderName });
            // set customerID for this folder (IEAdmins)
            this.setState({ customerID: folder.customerID });
        }
             
    }

    changeName = (event) => {
        this.setState({ folderName: event.target.value });
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    handleSubmit = (event) => {
        event.preventDefault()

        // folder ID
        if (this.props.popupInfo == null) {
            this.props.createFolder(this.state.folderName, this.state.customerID);
        } else {
            this.props.editFolder(this.props.popupInfo, this.state.folderName, this.state.customerID);
        }
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    populateCustomers = () => {
        return (
            <Select
                className="myInput"
                defaultValue=""
                onChange={this.handleCustomerID}
                value={this.state.customerID}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
            >
                <MenuItem value="" disabled hidden>Select Customer</MenuItem>

                {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
            </Select>
        )
    }

  
    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    {(this.props.popupInfo == null) ? "Add New Folder" : "Edit Folder"}
        </DialogTitle>
                <DialogContent>
                    <form className="form" onSubmit={this.handleSubmit} >
                        {(this.props.user.role === "IEAdmin" && this.props.popupInfo == null ) ? this.populateCustomers() : null}
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeName}
                                value={this.state.folderName}
                                placeholder="Folder Name"
                                required
                            />
                        </div>
                        <button className="btn" type="submit" value="Submit" id="submit_btn">
                            Submit
                    </button>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }

}


function mapStateToProps(state) {
    return {
        user: state.users,
        popupInfo: state.ui.popupInfo,
        folderList: state.users.folderList,
        customerList: state.users.customerList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createFolder, editFolder }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditFolder)